export default __webpack_public_path__ + "static/media/008-arc.03cf7bc9.svg";